cafm.offline = {

    _actions: null,
    serviceWorkerURL: '/cafm.serviceworker.js',
    getActions: function(){

        // if we haven't taken the actions out of the cache yet, get them
        if (!cafm.util.hasItem(this._actions)) {
            this._actions = cafm.cache.get(cafm.res.consts.CacheKey_OfflineActions);
        }

        // if there is nothing then create a new array
        if (!isArray(this._actions)) {

            this._actions = [];
        }

        // return the actions
        return this._actions;
    },
    clearActions: function () {

        var as = this.getActions();

        if (cafm.util.hasItem(as)) {

            // uncache the work orders that were processed 
            as.forEach(function (a) {

                cafm.hd.workOrderCachingHandler.removeItem(a.parentId);
            });            
        }

        this._actions = null;

        // remove actions from the cache
        cafm.cache.remove(cafm.res.consts.CacheKey_OfflineActions);
    },
    addAction: function (e) {

        // check the type and json are present
        if (!e || !e.type || !e.json) {

            console.log('cafm.offline.addAction arguments invalid');
            return false;
        }

        // get the actions
        var actions = this.getActions();

        // if the object has a toJSON function call it
        if (isFunc(e.json.toJSON)) {

            e.json = e.json.toJSON();
        }

        // create the action
        var a = {
            actionDateTime: new Date()
        };

        // add type and json to the action
        $.extend(a, e);

        // if helpdesk set the ID and reference off the work order in context
        if (cafm.getCurrentModule() == cafm.enums.CAFMModuleEnum.Helpdesk) {

            var w = cafm.hd.workOrder;
            a.parentId = w.ID;
            a.reference = w.Reference;
        }

        if (e.key) {

            cafm.util.removeWhere(actions, function (act) { return act._key === e.key });
            a._key = e.key;
        }

        // add the action
        actions.push(a);

        // set the actions in the cache
        cafm.cache.set(cafm.res.consts.CacheKey_OfflineActions, actions);

        // action added successfully
        return true;
    },
    processActions: function () {

        // get the actions
        var cached = this.getActions();

        // if there are actions then send them to the server for processing
        if (cafm.util.hasItem(cached)) {

            cafm.offline.isProcessing = true;

            cafm.actions.execute({
                url: cafm.url.api('WorkOrder/ProcessOfflineActions'),
                values: {
                    actions: cached
                },
                suppressErrors: true,
                executeDelay: 3000,
                executeDelayId: 'processActionsTimeout',
                timeout: 6000000, // we don't want a timeout
                loaderSelector: '#main',
                loaderText: cafm.res.str.MessageProcessingOfflineWorkOrders,
                complete: function (r, s, m, action) {

                    try {

                        // if it's a 200/500 then clear out the actions
                        // anything else is a problem with the website
                        if ([200,500].indexOf(r.status) > -1) {

                            if (r.status == 200 && r.responseJSON && cafm.util.hasItem(r.responseJSON.actionResults)) {

                                // loop the results
                                r.responseJSON.actionResults.forEach(function (res) {

                                    // log the result message
                                    console.log(res.message);

                                    // if it's an error then decache the work order
                                    if (res.messageType == cafm.enums.MessageType.Error) {

                                        cafm.hd.workOrderCachingHandler.removeItem(res.parentId);
                                    }
                                });
                            }

                            // now clear the offline actions
                            cafm.offline.clearActions();

                            // if viewing my jobs or the work order view then refresh
                            if (cafm.nav.isNav(cafm.enums.Navigatable.HelpdeskMyJobs, cafm.enums.Navigatable.HelpdeskEditWorkOrder)) {

                                cafm.util.callFunctionAsync({
                                    func: function () {
                                        cafm.nav.router.refresh();
                                    }, timeout: 250
                                });
                            }
                            
                        }
                    }
                    finally {

                        // clear the is processing flag
                        delete cafm.offline.isProcessing;
                    }
                }
            });
        }
    },
    registerServiceWorker: function () {
        if ('serviceWorker' in navigator) {
            window.addEventListener('load', () => {
                navigator.serviceWorker.register(cafm.offline.serviceWorkerURL)
                    .then(reg => {
                        console.log('Registered Service Worker successfully');
                    })
                    .catch(err => {
                        console.log('Error registering Service Worker' + err);
                    })

            });
        }
    },
    uregisterServiceWorker: function () {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.getRegistration(cafm.offline.serviceWorkerURL).then(function (reg) {
                reg.unregister()
                    .then(() => {
                        caches.keys().then(key => {
                            caches.delete(key);
                        }).finally(() => {
                            console.log('Unregistered Service Worker successfully');
                        });
                })
                .catch(err => {
                     console.log('Error unregistering Service Worker' + err);
                })
            });
        }
    }
}

cafm.setOffline = function(isOffline){

    cafm._isOffline = isOffline && cafm.isOfflineEnabled();
        
    // if not offline
    if (isOffline === false) {

        // cache the flag as we need to check this later
        cafm.cache.set(cafm.res.consts.CacheKey_IsOffline, isOffline);

        // hide the message
        $('.offlineMsg').hideMessage().html('');

        // process any offline actions now back online
        cafm.offline.processActions();

        // hide the menu button when offline
        $('#menuBtn').show();
    }
    else {

        // cache the flag as we need to check this later
        cafm.cache.set(cafm.res.consts.CacheKey_IsOffline, isOffline);
            
        // hide the menu button when offline
        $('#menuBtn').hide();
    }
};
cafm.isOffline = function () {
    /// <summary>Returns the is offline flag</summary>

    return cafm._isOffline === true;
};
cafm.isOfflineEnabled = function () {

    return cafm.getClientSettings().offlineEnabled;
};